import React, { useEffect, useState } from "react";
import { createRack, deleteRack, fetchAllRack, updateRack } from "../../../resources/RackResource"
import DataTable from 'react-data-table-component';
import { fetchAllWarehouse } from "../../../resources/WarehouseResource";
import { Link } from "react-router-dom";
import { showSuccessToast } from "../../../utils/GlobalToast";
import { format } from "date-fns";
import { getLocalAuth } from "../../../utils/AuthUtils";
import ErrorNotFound from "../../errors/Error";

function Rack() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Rack"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  let dataCreate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Create"
  });

  let dataUpdate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Update"
  });

  let dataDelete = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Delete"
  });

  const [dataRack, setDataRack] = useState([]);
  const [dataWarehouse, setDataWarehouse] = useState([]);
  const [name, setName] = useState("");
  const [warehouseId, setWarehouseId] = useState("default");
  const [warehouseIdFilter, setWarehouseIdFilter] = useState("default");
  const [capacity, setCapacity] = useState(1);
  const [selectedOption, setSelectedOption] = useState("landscape");

  const [idEdit, setIdEdit] = useState(null);
  const [nameEdit, setNameEdit] = useState("");
  const [capacityEdit, setCapacityEdit] = useState(1);
  const [warehouseIdEdit, setWarehouseIdEdit] = useState(null);
  const [xLocationEdit, setXLocationEdit] = useState(50);
  const [yLocationEdit, setYLocationEdit] = useState(50);
  const [selectedOptionEdit, setSelectedOptionEdit] = useState("");

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchRack = () => {
    fetchAllRack()
      .then((res) => {
        setDataRack(res.data);
      })
      .catch((err) => {
        setDataRack([]);
      });
  };

  const fetchWarehouse = () => {
    fetchAllWarehouse()
      .then((res) => {
        setDataWarehouse(res.data);
      })
      .catch((err) => {
        setDataWarehouse([]);
      });
  };

  useEffect(() => {
    fetchRack();
    fetchWarehouse();

  }, []);

  let filteredItems = warehouseIdFilter === "default" ? dataRack : dataRack.filter(item => {
    // eslint-disable-next-line
    return item.warehouse_id == warehouseIdFilter;
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    postRack(name, warehouseId, capacity, selectedOption);
  }

  function onValueChange(event) {
    setSelectedOption(event.target.value)
  }

  function onValueChangeEdit(event) {
    setSelectedOptionEdit(event.target.value)
  }

  const postRack = (name, warehouseId, capacity, selectedOption) => {
    setIsLoading(true);
    if (warehouseId === "default") {
      setIsLoading(false);
      setError("You haven't selected a warehouse yet");
      setIsError(true);
    } else {
      createRack(name, warehouseId, capacity, 50, 50, selectedOption).then((res) => {
        setIsLoading(false);
        setIsError(false);
        showSuccessToast("Success Added Rack!");
        setShowAddModal(false);
        setName("");
        setWarehouseId("default");
        setCapacity(1);
        setTimeout(() => {
          fetchRack();
        }, 200);

      }).catch((err) => {
        setIsLoading(false);
        setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
        setIsError(true);
      });
    }
  }

  const handleData = (data) => {
    setIdEdit(data.id);
    setNameEdit(data.name);
    setCapacityEdit(data.capacity);
    setWarehouseIdEdit(data.warehouse_id);
    setXLocationEdit(data.x_location);
    setYLocationEdit(data.y_location);
    setSelectedOptionEdit(data.rack_type);
  }

  const handleDelete = () => {
    setIsLoading(true);
    deleteRack(idEdit).then((res) => {
      setIsError(false);
      showSuccessToast("Success Deleted Rack!");
      setShowDeleteModal(false);
      setIsLoading(false);
      fetchRack();
    }).catch((err) => {
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
      setIsLoading(false);
    });
  }

  const handleEdit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updateRack(idEdit, nameEdit, warehouseIdEdit, capacityEdit, xLocationEdit, yLocationEdit, selectedOptionEdit).then((res) => {
      setIsLoading(false);
      setIsError(false);
      showSuccessToast("Success Updated Rack!");
      setShowEditModal(false);
      fetchRack();
    }).catch((err) => {
      setIsLoading(false);
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
    });
  }

  const onChangeHandler = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setWarehouseId(option);
  };

  const onChangeHandlerEdit = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setWarehouseIdEdit(option);
  };

  const onChangeHandlerWarehouseFilter = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setWarehouseIdFilter(option);

    fetchRack();
  };

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Capacity',
      selector: row => `${row.capacity} pcs`,
      sortable: true,
    },
    {
      name: 'Total Part',
      selector: row => `${row.total_part} pcs`,
      sortable: true,
    },
    {
      name: 'Occupancy',
      selector: row => `${row.occupancy === null ? 0 : Math.round(row.occupancy)}%`,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Updated At',
      selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          {dataDelete.length === 0 ? <div></div> : !dataDelete[0].is_active ? <div></div> : <button type="button" style={{ marginRight: "8px" }} className="btn btn-danger" onClick={() => {
            handleData(row);
            setShowDeleteModal(true);
          }}>Delete</button>}
          <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} aria-label="Close"></button>
                </div>
                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  {`You will delete ${nameEdit}`}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                  {!isLoading ? <button type="submit" className="btn btn-danger" onClick={() => handleDelete()}>Delete</button> :
                    <button className="btn btn-danger" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading...</button>}
                </div>
              </div>
            </div>
          </div>
          {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info" onClick={() => {
            handleData(row);
            setShowEditModal(true);
          }}>View</button>}
          <div className={`modal fade ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Master Data Rack</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                </div>
                {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <form onSubmit={handleEdit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Name</label>
                      <input required type="text" value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Warehouse</label>
                      <select className="form-select mb-3" aria-label="Default select example"
                        value={warehouseIdEdit}
                        onChange={onChangeHandlerEdit}>
                        {
                          dataWarehouse.map((data) => {
                            return (<option id={data.id}
                              name={data.name}
                              key={data.id}
                              value={data.id}>{data.name}</option>);
                          })
                        }
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Type Rack</label>
                      <div className="row mt-1">
                        <div className="col">
                          <div className="form-check">
                            <input className="form-check-input" type="radio" value="landscape" checked={selectedOptionEdit === "landscape"}
                              onChange={onValueChangeEdit} />
                            <div style={{
                              paddingLeft: '8px',
                              paddingRight: '8px',
                              backgroundColor: '#198fed',
                              width: '80px',
                              height: '44px',
                              textAlign: 'center',
                              alignContent: 'center',
                              color: '#FFF',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}>Rack Name</div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-check">
                            <input className="form-check-input" type="radio" value="potrait" checked={selectedOptionEdit === "potrait"}
                              onChange={onValueChangeEdit} />
                            <div style={{
                              paddingLeft: '8px',
                              paddingRight: '8px',
                              backgroundColor: '#5a7684',
                              width: '50px',
                              height: '80px',
                              textAlign: 'center',
                              alignContent: 'center',
                              color: '#FFF',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}>Rack Name</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Capacity</label>
                      <input required type="number" value={capacityEdit} onChange={(e) => setCapacityEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                      {!isLoading ? <button type="submit" className="btn btn-info">Save</button> :
                        <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...</button>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>

      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col">
                      <h4 className="mb-0">Master Data Rack</h4>
                    </div>
                    <div className="col">
                      <div className="text-end">
                        {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <Link to='/admin/rack/setting-layout' style={{ marginRight: '8px' }}>
                          <button type="button" className="btn btn-success ms-auto radius-10"><i className='bx bx-layout'></i> Setting Layout</button>
                        </Link>}
                        {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto radius-10" onClick={() => {
                          setShowAddModal(true);
                        }}><i className='bx bx-plus'></i> Rack</button>}
                      </div>
                    </div>
                    <div className={`modal fade ${showAddModal ? 'show' : ''}`} style={{ display: showAddModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Master Data Rack</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowAddModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Name</label>
                                <input required type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Warehouse</label>
                                <select className="form-select mb-3" aria-label="Default select example"
                                  value={warehouseId}
                                  onChange={onChangeHandler}>
                                  <option value="default" disabled>Select Warehouse</option>
                                  {
                                    dataWarehouse.map((data) => {
                                      return (<option id={data.id}
                                        name={data.name}
                                        key={data.id}
                                        value={data.id}>{data.name}</option>);
                                    })
                                  }
                                </select>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Type Rack</label>
                                <div className="row mt-1">
                                  <div className="col">
                                    <div className="form-check">
                                      <input className="form-check-input" type="radio" value="landscape" checked={selectedOption === "landscape"}
                                        onChange={onValueChange} />
                                      <div style={{
                                        paddingLeft: '8px',
                                        paddingRight: '8px',
                                        backgroundColor: '#198fed',
                                        width: '80px',
                                        height: '44px',
                                        textAlign: 'center',
                                        alignContent: 'center',
                                        color: '#FFF',
                                        fontSize: '12px',
                                        fontWeight: '600'
                                      }}>Rack Name</div>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="form-check">
                                      <input className="form-check-input" type="radio" value="potrait" checked={selectedOption === "potrait"}
                                        onChange={onValueChange} />
                                      <div style={{
                                        paddingLeft: '8px',
                                        paddingRight: '8px',
                                        backgroundColor: '#5a7684',
                                        width: '50px',
                                        height: '80px',
                                        textAlign: 'center',
                                        alignContent: 'center',
                                        color: '#FFF',
                                        fontSize: '12px',
                                        fontWeight: '600'
                                      }}>Rack Name</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Capacity</label>
                                <input required type="number" className="form-control" value={capacity} onChange={(e) => setCapacity(e.target.value)} />
                              </div>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowAddModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Warehouse :</label>
                    <select className="form-select mb-3" aria-label="Default select example"
                      value={warehouseIdFilter}
                      onChange={(e) => onChangeHandlerWarehouseFilter(e)}>
                      <option value="default" id="default">All Warehouse</option>
                      {
                        dataWarehouse.map((data) => {
                          return (<option id={data.id}
                            key={data.id}
                            value={data.id}>{data.name}</option>);
                        })
                      }
                    </select>
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={filteredItems}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Rack